import { success, error, abort } from 'redux-saga-requests';
import { GET_TRAINER_RESOURCES } from '../constants';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_TRAINER_RESOURCES: {
      return {
        ...state,
        [action.meta.name]: {
          response: state[action.meta.name] ? state[action.meta.name].response : undefined,
          resolved: false,
          failed: false,
          error: null,
        },
      };
    }
    case success(GET_TRAINER_RESOURCES): {
      return {
        ...state,
        [action.meta.name]: {
          response: action.payload.data.content,
          resolved: true,
          failed: false,
          error: null,
        },
      };
    }
    case error(GET_TRAINER_RESOURCES): {
      if (action.payload.response.status >= 400 && action.payload.response.status < 600) {
        return {
          ...state,
          [action.meta.name]: {
            resolved: true,
            failed: true,
            error: action.payload.response.data.result.errorCode,
          },
        };
      }
      return {
        ...state,
        [action.meta.name]: {
          resolved: true,
          failed: true,
          error: action.payload.toString ? action.payload.toString() : '',
        },
      };
    }
    case abort(GET_TRAINER_RESOURCES):
      return {
        ...state,
      };
    default:
      return state;
  }
}
